export const styles = {
  TooltipWrapper: {
    width: 157,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  TooltipText: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#FFFFFF",
  },
  TooltipProps: {
    background: "#000000CC",
    borderRadius: "4px",
    px: "8px",
    py: "4px",
  },
};
